import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { PaymentProcessing } from '~pages/payments/payment-processing/index';
import { UserRoles } from '~entities/users/model/types';
import { checkMinRoleValue } from '~shared/utils/role-guard';

const PendingComponent = () => {
  return (
    <div className='flex h-screen items-center justify-center'>Loading....</div>
  );
};

const paymentProcessingSearchSchema = z.object({
  tab: z.enum(['history', 'pending']).optional(),
});

export const Route = createFileRoute(
  '/_auth/_layout/payment/payment-processing',
)({
  validateSearch: zodValidator(paymentProcessingSearchSchema),
  beforeLoad: async () => {
    const hasAccess = await checkMinRoleValue(UserRoles.SUPER_ADMIN);
    if (!hasAccess) {
      return redirect({
        to: '/dashboard',
      });
    }
  },
  pendingComponent: PendingComponent,
  component: PaymentProcessing,
});
